'use strict';

require('./cn-login.scss');

module.exports = {
  template: require('./cn-login.html'),
  controllerAs: 'vm',
  transclude: true,

  bindings: {
    titleText: '@'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-login/index.js
 ** module id = 122
 ** module chunks = 0
 **/